import React, { useEffect, useState } from 'react'
import { useApolloClient } from '@apollo/client'
import Grid from '@material-ui/core/Grid'
import ErrorIcon from '@material-ui/icons/Error'
import Typography from '@material-ui/core/Typography'
import StoryCard from '../../../StoryCard'
import { SIGN_FILE_LINKS } from '../../../../network/stories/queries'
import { VIDEO_TYPE } from '../../../../constants/story'

import { useStyles } from './styles'

const StoryHighlights = ({
  data: {
    stories: { highlights, total }
  }
}) => {
  const client = useApolloClient()
  const [linksPairs, setLinksPairs] = useState(null)

  useEffect(() => {
    if (highlights.length) {
      const combinedLinks = {}
      const linksToSingArray = highlights
        .filter(story => story.resourceType === VIDEO_TYPE && story.thumbnailLocation)
        .map(story => story.thumbnailLocation)

      ;(async () => {
        const { data: signedLinks } = await client.query({
          query: SIGN_FILE_LINKS,
          variables: { linksToSign: linksToSingArray },
          fetchPolicy: 'no-cache'
        })
        linksToSingArray.forEach((link, idx) => {
          combinedLinks[link] = signedLinks.me.security.signFileLinks[idx]
        })

        setLinksPairs(combinedLinks)
      })()
    }
  }, [highlights, client])
  const classes = useStyles()
  return (
    <Grid container item xs={12} className={classes.row}>
      <div className={classes.label}>
        <Typography variant='h6' component='div'>
          STORY HIGHLIGHTS
        </Typography>
      </div>
      {!highlights.length ? (
        <div className={classes.empty}>
          <div className={classes.icon}>
            <ErrorIcon />
          </div>
          <Typography variant='h5' component='div' className={classes.header}>
            {total ? 'Your learners haven’t shared any stories yet!' : 'No Stories Have Been Captured!'}
          </Typography>
          <Typography variant='h5' component='div' className={classes.text}>
            {total ? 'Your learners haven’t shared any stories yet!' : 'Your learners haven’t captured any stories yet!'} Give them a nudge
            with an note. Click here to go to ‘Management’ so you can generate an email list.
          </Typography>
        </div>
      ) : (
        <Grid container item xs={12} className={classes.storyHighlights} spacing={4}>
          {highlights.map(card => (
            <StoryCard key={card.id} card={card} linksPairs={linksPairs} />
          ))}
        </Grid>
      )}
    </Grid>
  )
}

export default StoryHighlights
